export default __webpack_public_path__ + "static/media/G&S.png.cbb39ceb.png";